'use strict';

const React = require('react');
const SVTLink = require('../../elements/SVTLink');
const LinkButton = require('../../elements/LinkButton.jsx');

const AutoCompleteLink = (props) => {
	const { target, button, children, ...other } = props;
	const followLink = (event) => { // This is needed because of the blur action on the input field
		event.preventDefault();
		if(typeof window !== 'undefined') {
			window.location.href = target;
		}
	};

	if(!target) { return (<noscript/>); }
	
	if(button) {
		return (
			<LinkButton onMouseDown={followLink} {...other} to={target}>
				{children}
			</LinkButton>
		);	
	}

	return (
		<SVTLink onMouseDown={followLink} {...other} to={target}>
			{children}
		</SVTLink>
	);
};

module.exports = AutoCompleteLink;




/** WEBPACK FOOTER **
 ** ./app/components/menu/search/AutoCompleteLink.js
 **/